import { $http } from "@/utils/http";
import axios from "axios";
import {
    SET_HEADER_SEARCH,
    SET_HEADER_SEARCH_LOADER,
    SHOW_NOT_RESULT_SEARCH_HEADER,
    SET_SEARCH_LIST_LOADER,
    SET_SEARCH_LIST,
    SHOW_NOT_RESULT_SEARCH,
    RESET_SEARCH,
    SEARCH_CHANGE_SKIP,
    SEARCH_SET_COUNT,
    SET_QUERY_SEARCH,
    RESET_HEADER_SEARCH_TOOLTIP,
} from "../mutation-types";

import { GET_SEARCH_LIST, GET_HEADER_SEARCH_TOOLTIP } from "../action-types";

const state = {
    resultHeaderSearch: [],
    searchList: null,
    querySearch: "",
    headerSearchLoader: false,
    searchLoader: false,
    noResultSearch: false,
    noResultSearchHeader: false,
    skip: 0,
    limit: 12,
    count: 0,
};

const getters = {
    searchList: state => state.searchList,
    limit: state => state.limit,
    skip: state => state.skip,
    count: state => state.count,
    querySearch: state => state.querySearch,
    resultHeaderSearch: state => state.resultHeaderSearch,
    headerSearchLoader: state => state.headerSearchLoader,
    searchLoader: state => state.searchLoader,
    noResultSearch: state => state.noResultSearch,
    noResultSearchHeader: state => state.noResultSearchHeader,
};

const actions = {
    [GET_HEADER_SEARCH_TOOLTIP]: async ({ commit }, payload) => {
        commit(SET_HEADER_SEARCH_LOADER, true);
        commit(RESET_HEADER_SEARCH_TOOLTIP);
        commit(SHOW_NOT_RESULT_SEARCH_HEADER, false);
        try {
            const response = await $http.post(`v1/catalog/get-products?search=${state.querySearch}`);
            response.data.data.length === 0
                ? commit(SHOW_NOT_RESULT_SEARCH_HEADER, true)
                : commit(SHOW_NOT_RESULT_SEARCH_HEADER, false);
            commit(RESET_HEADER_SEARCH_TOOLTIP);
            commit(SET_HEADER_SEARCH, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(SET_HEADER_SEARCH_LOADER, false);
        }
    },
    [GET_SEARCH_LIST]: async ({ commit }, payload) => {
        commit(SET_SEARCH_LIST_LOADER, true);
        commit(SHOW_NOT_RESULT_SEARCH, false);
        try {
            const response = await $http.post(
                `v1/catalog/get-products?search=${state.querySearch}&limit=${state.limit}&skip=${state.skip}`
            );
            response.data.data.total === 0
                ? commit(SHOW_NOT_RESULT_SEARCH, true)
                : commit(SHOW_NOT_RESULT_SEARCH, false);
            commit(SEARCH_SET_COUNT, response.data.meta.count);
            commit(RESET_SEARCH);
            commit(SET_SEARCH_LIST, response.data.data.products.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_SEARCH_LIST_LOADER, false);
        }
    },
};

const mutations = {
    [SET_HEADER_SEARCH](state, list) {
        state.resultHeaderSearch = list;
    },
    [SET_QUERY_SEARCH](state, query) {
        state.querySearch = query;
    },
    [SET_SEARCH_LIST](state, list) {
        state.searchList = list;
    },
    [RESET_HEADER_SEARCH_TOOLTIP](state) {
        state.resultHeaderSearch = [];
    },
    [RESET_SEARCH](state) {
        state.searchList = null;
    },
    [SET_HEADER_SEARCH_LOADER](state, status) {
        state.headerSearchLoader = status;
    },
    [SET_SEARCH_LIST_LOADER](state, status) {
        state.searchLoader = status;
    },
    [SHOW_NOT_RESULT_SEARCH_HEADER](state, status) {
        state.noResultSearchHeader = status;
    },
    [SHOW_NOT_RESULT_SEARCH](state, status) {
        state.noResultSearch = status;
    },
    [SEARCH_CHANGE_SKIP](state, count) {
        state.skip = count;
    },
    [SEARCH_SET_COUNT](state, count) {
        state.count = count;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
